import styled from 'styled-components/macro'
import { mq } from 'styles/mq'

export const SocialContainer = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  margin: 4rem 0 10rem;

  ${mq.medium} {
    gap: 4rem;
    justify-content: center;
  }

  svg {
    width: 5rem;
    height: 5rem;
  }

  a {
    color: inherit;
  }

  a:hover,
  a:focus-visible {
    color: #ccc;
  }
`
